export default {
  blank: () => import("/home/anhnq/project/personal/alobacsi/user-app/src/layouts/blank.vue").then(m => m.default || m),
  default: () => import("/home/anhnq/project/personal/alobacsi/user-app/src/layouts/default.vue").then(m => m.default || m)
}